import {
  DashboardLoadingSkeleton,
  DashboardEmptyState,
  DashboardErrorState,
  DashboardHeader,
  DashboardResultsInfo,
  DashboardsList,
} from "@/components/dashboard";
import { Icon } from "@iconify/react";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAllDashboards } from "@/hooks";
import { IDashboard } from "@/types/dashboard.types";

export default function DashboardsPage() {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");

  const {
    data: dashboardsResponse,
    isLoading,
    error,
    refetch,
  } = useGetAllDashboards();

  const dashboards: IDashboard[] = dashboardsResponse?.data || [];

  const filteredDashboards = useMemo(() => {
    if (!searchQuery) return dashboards;
    const query = searchQuery.toLowerCase();
    return dashboards.filter(
      (dashboard) =>
        dashboard.name.toLowerCase().includes(query) ||
        (dashboard.widgets ?? []).some((widget) =>
          widget.title.toLowerCase().includes(query)
        )
    );
  }, [dashboards, searchQuery]);

  return (
    <div className="container mx-auto px-4 py-8 max-w-screen-md">
      <DashboardHeader />

      <div className="mb-12 flex justify-center relative items-center space-x-2 rounded-md pl-4 h-[48px] w-full bg-subprimary text-sm">
        <Icon icon="lucide:search" fontSize={18} className="text-textIcon" />
        <input
          type="text"
          placeholder={t("common.search")}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="outline-none flex-1 bg-inherit"
        />
      </div>

      {isLoading ? (
        <DashboardLoadingSkeleton />
      ) : error ? (
        <DashboardErrorState error={error as Error} onRetry={refetch} />
      ) : filteredDashboards.length === 0 ? (
        <DashboardEmptyState searchQuery={searchQuery} />
      ) : (
        <DashboardsList dashboards={filteredDashboards} />
      )}

      <DashboardResultsInfo
        currentCount={filteredDashboards.length}
        totalCount={dashboards.length}
      />
    </div>
  );
}
